export const ACTIVE_GAME_SESSION_STORAGE_KEY = 'cq_active_game_session_v1';
export const ACTIVE_GAME_SESSION_SNAPSHOT_VERSION = 1;

const isObject = (value) => (
  value !== null &&
  typeof value === 'object' &&
  !Array.isArray(value)
);

const getStorage = () => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return null;
  }

  return window.localStorage;
};

export const createActiveGameSessionSnapshot = (values = {}) => {
  const now = new Date().toISOString();

  return {
    status: 'active',
    selectedQuestPack: null,
    currentQuestion: { question: '', round: null },
    players: {},
    messageCount: 1,
    aiReplyCount: 0,
    totalUsage: {},
    sessionLimits: {},
    activeTools: [],
    realtimeConfig: {},
    conversationSummary: '',
    transcript: [],
    startedAt: now,
    lastActivityAt: now,
    ...values,
    version: ACTIVE_GAME_SESSION_SNAPSHOT_VERSION,
    lastSavedAt: now,
  };
};

export const isValidActiveGameSessionSnapshot = (snapshot) => (
  isObject(snapshot) &&
  snapshot.version === ACTIVE_GAME_SESSION_SNAPSHOT_VERSION &&
  typeof snapshot.gameSessionId === 'string' &&
  snapshot.gameSessionId.trim().length > 0 &&
  typeof snapshot.selectedGamePack === 'string' &&
  snapshot.selectedGamePack.trim().length > 0
);

export const readActiveGameSessionSnapshot = () => {
  const storage = getStorage();

  if (!storage) {
    return null;
  }

  try {
    const rawSnapshot = storage.getItem(ACTIVE_GAME_SESSION_STORAGE_KEY);

    if (!rawSnapshot) {
      return null;
    }

    const parsedSnapshot = JSON.parse(rawSnapshot);

    if (!isValidActiveGameSessionSnapshot(parsedSnapshot)) {
      storage.removeItem(ACTIVE_GAME_SESSION_STORAGE_KEY);
      return null;
    }

    return parsedSnapshot;
  } catch (error) {
    try {
      storage.removeItem(ACTIVE_GAME_SESSION_STORAGE_KEY);
    } catch {
      // Ignore cleanup failures. The caller should still continue without a snapshot.
    }
    return null;
  }
};

export const writeActiveGameSessionSnapshot = (snapshot) => {
  const storage = getStorage();
  const nextSnapshot = createActiveGameSessionSnapshot(snapshot);

  if (!storage || !isValidActiveGameSessionSnapshot(nextSnapshot)) {
    return null;
  }

  try {
    storage.setItem(ACTIVE_GAME_SESSION_STORAGE_KEY, JSON.stringify(nextSnapshot));
    return nextSnapshot;
  } catch (error) {
    return null;
  }
};

export const clearActiveGameSessionSnapshot = () => {
  const storage = getStorage();

  if (!storage) {
    return;
  }

  try {
    storage.removeItem(ACTIVE_GAME_SESSION_STORAGE_KEY);
  } catch {
    // Ignore cleanup failures.
  }
};
